module.exports = __webpack_public_path__ + "static/media/cert_10.8cb9a686.jpg";